// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__euN75","author":"Table_author__2x-R0","authorImage":"Table_authorImage__2Sg4P","unreadRow":"Table_unreadRow__2hq-a"};